var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSubmit)?_c('input',{attrs:{"type":"submit"},domProps:{"value":this.$slots['default'] !== undefined ? this.$slots['default'][0].text: ''}}):_c('button',{class:[_vm.outline ? 'outline': '']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }